export const FACTORS = [
  {
    "id": "N",
    "name": "Neuroticism",
    "altName": "Emotional Stability",
    "icon": "🌊",
    "color": "#7c3aed",
    "bg": "#f5f3ff",
    "domain": "Emotional",
    "lowLabel": "Emotionally Stable",
    "highLabel": "Neurotic / Reactive",
    "lowDesc": "Calm, resilient, emotionally stable. Handles stress without excessive worry.",
    "highDesc": "Prone to negative emotions and stress. May experience mood instability.",
    "concerns": {
      "low": [
        "May underestimate emotional risks",
        "Can seem detached to expressive colleagues"
      ],
      "high": [
        "Emotional reactivity disrupts team climate",
        "Anxiety can impair decision quality"
      ]
    },
    "development": {
      "low": [
        "Develop emotional empathy skills"
      ],
      "high": [
        "Mindfulness and emotional regulation practice",
        "Cognitive reframing skills"
      ]
    }
  },
  {
    "id": "E",
    "name": "Extraversion",
    "altName": "Introversion (low end)",
    "icon": "⚡",
    "color": "#d97706",
    "bg": "#fef3c7",
    "domain": "Social",
    "lowLabel": "Introverted / Reserved",
    "highLabel": "Extraverted / Outgoing",
    "lowDesc": "Reserved and energised by solitude. Prefers depth over breadth in social interactions.",
    "highDesc": "Outgoing, talkative and energised by social interaction.",
    "concerns": {
      "low": [
        "May appear distant",
        "Limited networking can restrict progression"
      ],
      "high": [
        "Social energy at cost of focus",
        "Can dominate conversations"
      ]
    },
    "development": {
      "low": [
        "Build intentional networking habits",
        "Increase visibility in meetings"
      ],
      "high": [
        "Build focused uninterrupted work time",
        "Practise active listening"
      ]
    }
  },
  {
    "id": "O",
    "name": "Openness to Experience",
    "altName": "Openness",
    "icon": "🔭",
    "color": "#0891b2",
    "bg": "#cffafe",
    "domain": "Intellectual",
    "lowLabel": "Conventional / Practical",
    "highLabel": "Open / Imaginative",
    "lowDesc": "Conventional, practical and focused on concrete facts and established methods.",
    "highDesc": "Intellectually curious, imaginative and open to new ideas.",
    "concerns": {
      "low": [
        "May resist change or innovation",
        "Discomfort with ambiguity"
      ],
      "high": [
        "May over-complicate simple problems",
        "Boredom with routine work"
      ]
    },
    "development": {
      "low": [
        "Expose yourself to new ideas and diverse conversations",
        "Practise horizon scanning"
      ],
      "high": [
        "Build completion discipline",
        "Ground thinking in operational reality"
      ]
    }
  },
  {
    "id": "A",
    "name": "Agreeableness",
    "altName": "Agreeableness",
    "icon": "🤝",
    "color": "#16a34a",
    "bg": "#dcfce7",
    "domain": "Interpersonal",
    "lowLabel": "Competitive / Challenging",
    "highLabel": "Agreeable / Cooperative",
    "lowDesc": "Competitive, sceptical and willing to challenge. Values truth over harmony.",
    "highDesc": "Trusting, cooperative and motivated to maintain positive relationships.",
    "concerns": {
      "low": [
        "Can damage relationships",
        "Perceived as combative"
      ],
      "high": [
        "Conflict avoidance enables underperformance",
        "Messages may be softened too much"
      ]
    },
    "development": {
      "low": [
        "Develop empathy and relational sensitivity",
        "Practise diplomatic feedback"
      ],
      "high": [
        "Build courage to deliver difficult messages",
        "Develop performance management skills"
      ]
    }
  },
  {
    "id": "C",
    "name": "Conscientiousness",
    "altName": "Conscientiousness",
    "icon": "📋",
    "color": "#1d4ed8",
    "bg": "#dbeafe",
    "domain": "Motivational",
    "lowLabel": "Flexible / Spontaneous",
    "highLabel": "Conscientious / Organised",
    "lowDesc": "Flexible, spontaneous and comfortable adapting without rigid structure.",
    "highDesc": "Organised, disciplined and driven to achieve. Plans carefully and follows through.",
    "concerns": {
      "low": [
        "Delivery unpredictability",
        "Perceived as disorganised"
      ],
      "high": [
        "Rigidity can limit creativity",
        "Perfectionism may slow execution"
      ]
    },
    "development": {
      "low": [
        "Build personal organisation systems",
        "Develop accountability structures"
      ],
      "high": [
        "Build tolerance for productive ambiguity",
        "Practise delegating detail work"
      ]
    }
  }
];
export const FACTOR_MAP = Object.fromEntries(FACTORS.map(f=>[f.id,f]));
export const NORMS = {"N":[3,6],"E":[4,7],"O":[4,7],"A":[5,8],"C":[4,7]};
